import React from "react";
import { FaLinkedin, FaGithub, FaArrowDown } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import profile from "../assets/profile-img.png";

const Hero = () => {
  const SOCIAL = [
    {
      id: 1,
      link: "https://www.linkedin.com/in/kidan-lakew/",
      icon: <FaLinkedin />,
    },
    {
      id: 2,
      link: "https://github.com/Kidan-Tekelearegy",
      icon: <FaGithub />,
    },
    {
      id: 1,
      link: "mailto:kidulakew@gmail.com",
      icon: <HiOutlineMail />,
    },
  ];
  /* In this case arrow function doesn't. work It will hide the arrow */
  window.addEventListener("scroll", function () {
    const downArrow = document.querySelector(".down-arrow");

    if (this.scrollY >= 2) downArrow.classList.add("hide-down-arrow");
    else downArrow.classList.remove("hide-down-arrow");
  });
  return (
    <section
      name="hero"
      className="min-h-screen flex flex-col justify-start items-center p-10 text-center"
    >
      <h2 className=" pt-20 text-5xl text-rose-600 uppercase font-bold">
        Kidan Lakew
      </h2>
      <h3 className="py-3 text-2xl">Junior frontend Developer</h3>
      <p className="max-w-xl font-light text-gray-900 dark:text-white">
        Hello, I'm a frontend developer who enjoys working on web and mobile app
        projects. I'm ready to take on new challenges and learn as I go. 
        
      </p>
      {/* Social icons */}
      <div className="flex justify-evenly py-8 lg-py-16 text-3xl w-full md:w-1/3">
        {SOCIAL.map(({ id, link, icon }) => (
          <a
            href={link}
            key={id}
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer duration-300 hover:text-green-600"
          >
            {icon}
          </a>
        ))}
      </div>
      {/* profile pic and resume */}
      <div>
        <img
          src={profile}
          alt="profile-img"
          className="w-60 h-60 md:w-72 md:h-72 object-cover object-top bg-gradient-to-b from-green-800 to-rose-500 rounded-full pt-5"
        />
        <a
          href="/Updated Cv(4).pdf"
          target="_blank"
          download={false}
          className="flex items-center justify-center mt-10 bg-gradient-to-r from-green-800 to-rose-500 text-white py-2 rounded-full  border-2 hover:bg-rose-600 hover:border-pink-600 px-4 my-8 mx-auto "
        >
          Check My Resume
        </a>
      </div>
      {/* arrow down animation */}
      <div className="mt-10 down-arrow">
        <FaArrowDown className="text-gray-400 text-2xl animate-bounce" />
      </div>
    </section>
  );
};

export default Hero;
